import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73d4ee74"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ui-pagination"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "ui-pagination__dots-divider" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "ui-pagination__dots-divider" }
const _hoisted_7 = ["onClick"]

import { ref, toRefs, computed } from 'vue'
import { CollectionMetadata } from '@/types'
import { usePaginationUrlQuery } from '@/composables/usePaginationUrlQuery'
import { useHelpers } from '@/composables/useHelpers'

type Props = {
    metadata: CollectionMetadata
    withUrlQuery?: boolean
}
type Emit = {
    (e: 'changePage', value: number): void
}

export default /*#__PURE__*/_defineComponent({
  props: {
    metadata: { type: null, required: true },
    withUrlQuery: { type: Boolean, required: false }
  },
  emits: ["changePage"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'changePage', value: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    metadata: CollectionMetadata
    withUrlQuery?: boolean
}




const { updateUrlQuery } = usePaginationUrlQuery()
const changePage = (newPage: number) => {
    if (props.withUrlQuery) {
        updateUrlQuery(String(newPage))
    }
    emit('changePage', newPage)
}

const { pageCount, page: currentPage } = toRefs(props.metadata)

const pages = ref<number[]>([])
const maxVisiblePages = 3
pages.value = [
    ...Array(pageCount.value > maxVisiblePages ? maxVisiblePages : pageCount.value).keys(),
].map(page => page + 1)

const { createArrayFromGivenRange } = useHelpers()
const shiftedPages = computed<number[]>(() => {
    switch (true) {
        case currentPage.value < maxVisiblePages:
            return [...Array(3).keys()].map(index => index + 1)
        case currentPage.value === pageCount.value:
            return createArrayFromGivenRange(pageCount.value - 2, pageCount.value)
        default:
            return createArrayFromGivenRange(currentPage.value - 1, currentPage.value + 1)
    }
})

return (_ctx: any,_cache: any) => {
  const _component_IconDots = _resolveComponent("IconDots")!

  return (props.metadata.pageCount > 1)
    ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
        (props.metadata.pageCount > maxVisiblePages)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_unref(currentPage) >= maxVisiblePages)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("li", null, [
                      _createElementVNode("div", {
                        class: "ui-pagination__button",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (changePage(1)))
                      }, " 1 ")
                    ]),
                    (_unref(shiftedPages)[0] !== 2)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_2, [
                          _createElementVNode("div", _hoisted_3, [
                            _createVNode(_component_IconDots)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(shiftedPages), (page) => {
                return (_openBlock(), _createElementBlock("li", { key: page }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["ui-pagination__button", { 'ui-pagination__button--active': page === props.metadata.page }]),
                    onClick: ($event: any) => (changePage(page))
                  }, _toDisplayString(page), 11, _hoisted_4)
                ]))
              }), 128)),
              (!_unref(shiftedPages).includes(_unref(pageCount)))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_unref(shiftedPages)[2] < _unref(pageCount) - 1)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
                          _createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_IconDots)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("li", null, [
                      _createElementVNode("div", {
                        class: "ui-pagination__button",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (changePage(props.metadata.pageCount)))
                      }, _toDisplayString(props.metadata.pageCount), 1)
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(pages.value, (page) => {
              return (_openBlock(), _createElementBlock("li", { key: page }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["ui-pagination__button", { 'ui-pagination__button--active': page === props.metadata.page }]),
                  onClick: ($event: any) => (changePage(page))
                }, _toDisplayString(page), 11, _hoisted_7)
              ]))
            }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})